import styled from 'styled-components';

import { brandFont } from 'styles/brand-font';
import { primitive } from 'styles/constants/primitives';

export const PriceAndCaloriesText = styled.h2`
  font: ${brandFont.headerThree};
  color: ${({ theme }) => theme.token('text-default')};
  width: 100%;
  text-align: center;
  text-transform: capitalize;
  margin-block-start: 0;
  margin-block-end: ${primitive.$spacing3};
`;
